export const initialStatuses = [
  { name: "Lead", disablesBadge: false },
  { name: "Richiamare", disablesBadge: false },
  { name: "Meeting", disablesBadge: false },
  { name: "Pending", disablesBadge: false },
  { name: "Registrati", disablesBadge: true },  // 🔥 Disattiva badge
  { name: "Scartati", disablesBadge: true },
  ];
